import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

type ResponsiveSpacing = { base: number; smUp: number };

export function cmsBlockContainerVariables({
  padding,
  headingDividerSpacing,
}: {
  padding: ResponsiveSpacing;
  headingDividerSpacing: ResponsiveSpacing;
}): Record<string, string> {
  return {
    '--cms-block-padding': `${padding.base}px`,
    '--cms-block-padding-sm-up': `${padding.smUp}px`,
    '--cms-block-heading-divider-spacing': `${headingDividerSpacing.base}px`,
    '--cms-block-heading-divider-spacing-sm-up': `${headingDividerSpacing.smUp}px`,
  };
}

export const CmsBlockContainerBox = styled.div`
  position: relative;
  width: 100%;

  &[data-show-heading-divider] {
    &[data-hide-first-heading-divider] h2:not(:first-child),
    &:not([data-hide-first-heading-divider]) h2 {
      width: 100%;

      &::before {
        content: '';
        display: block;
        margin: 0 auto;
        margin-bottom: var(--cms-block-heading-divider-spacing);
        width: 100%;
        max-width: 1200px;
        height: 1px;
        background: ${colors.selectionGrey};

        @media all and (min-width: ${cssBreakpoints.smUp}) {
          margin-bottom: var(--cms-block-heading-divider-spacing-sm-up);
        }
      }
    }
  }

  &[data-has-background]::before {
    content: '';
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${colors.backgroundGrey};
  }

  &[data-has-background][data-type='SPLIT_CONTENT'] {
    &::before {
      content: none;
    }

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      &::before {
        content: '';
      }
    }
  }

  &[data-mt] {
    margin-top: var(--cms-block-padding);
  }

  &[data-mb] {
    margin-bottom: var(--cms-block-padding);
  }

  &[data-pt] {
    padding-top: var(--cms-block-padding);
  }

  &[data-pb] {
    padding-bottom: var(--cms-block-padding);
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    &[data-mt] {
      margin-top: var(--cms-block-padding-sm-up);
    }

    &[data-mb] {
      margin-bottom: var(--cms-block-padding-sm-up);
    }

    &[data-pt] {
      padding-top: var(--cms-block-padding-sm-up);
    }

    &[data-pb] {
      padding-bottom: var(--cms-block-padding-sm-up);
    }
  }
`;
